<template>
    <div v-b-tooltip.hover.top.html="getTooltipData()" class="chat-user-carousel-item-root">
        <div class="chat-button-wrapper clickable" @click="onClick">
            <div class="chat-button" :style="!avatar ? 'background-color: var(--primary)' : ''">
                <div
                    v-if="!!avatar"
                    class="avatar"
                    :style="{
                        backgroundImage: 'url(\'' + avatar + '/small.jpg\')',
                    }"
                />
                <div v-else-if="!!getInitials" class="avatar-letter">
                    <span> {{ getInitials }} </span>
                </div>
                <div v-else style="display:flex;align-items:center;">
                    <BaseIcon class="icon" name="user" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnalyticService from '../../../services/AnalyticService';

export default {
    name: 'ChatUserCarouselItem',
    props: {
        displayName: String,
        avatar: String,
        id: String,
        title: String,
        companyId: Number,
        companyTitle: String,
    },
    data() {
        return {
            clicked: false,
        };
    },
    computed: {
        getInitials() {
            let { displayName } = this;
            if (!!displayName) {
                let initials = this.displayName.match(/\b\w/g) || [];
                initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
                return initials;
            }
            return '';
        },
    },
    methods: {
        onClick() {
            if (!this.clicked) {
                AnalyticService.chatStartEvent(this.companyId, this.companyTitle);
            }
            this.clicked = true;
            this.$emit('click');
        },
        firstLetterOfName() {
            let { displayName } = this;
            return displayName ? displayName[0] : 'A';
        },
        getTooltipData() {
            let title = Boolean(this.title) ? '<br /><strong>' + this.title + '</strong>' : '';

            return {
                title: `<div style='text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;'>${
                    this.displayName
                }${title}</div>`,
            };
        },
    },
};
</script>

<style lang="css" scoped>
.chat-user-carousel-item-root {
    width:50px;
    margin:auto;
}
.chat-button-wrapper {
    height: 60px;
    width: 60px;
}
.chat-button {
    width: 100%;
    height: 100%;
    font-size: 100%;
    border-radius: 50%;
    box-shadow: var(--shadow);
    overflow: hidden;
    border:3px solid #00ca49;
}
.avatar {
    width: 100%;
    height: 100%;
    background: no-repeat center center;
    background-size: cover;
}
.avatar-letter {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    height: 100%;
    width: 100%;
    color: white;
}
</style>
